import axios from "axios";

const fetchViability = (viabilityUrl, uf) =>
  axios.get(viabilityUrl, { params: { uf } }).then((response) => response.data);

export { fetchViability };
